import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/codebuild/output/src208624450/src/ema-agencies/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src208624450/src/ema-agencies/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src208624450/src/ema-agencies/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src208624450/src/ema-agencies/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src208624450/src/ema-agencies/src/components/global/lonely.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src208624450/src/ema-agencies/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src208624450/src/ema-agencies/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src208624450/src/ema-agencies/src/i18n.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src208624450/src/ema-agencies/src/providers/modal-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/codebuild/output/src208624450/src/ema-agencies/src/providers/theme-provider.tsx");
